module.exports = __webpack_public_path__ + "static/school-support-testimonial-1d3a3ecccbe35109b139b73610050582.jpg";